// EL ACCESO DE AUDITOR, EN PALABRAS · Fase 2 del despegue.
//
// El estado se calcula del servidor, no se guarda: un acceso «activo»
// guardado se queda viejo entre dos consultas, porque caducar es una
// cosa que hace el reloj y no una persona.
import { ESTADO_POR_DEFECTO } from './estados';

export const ESTADO_INVITADO = {
  ACTIVO: { etiqueta: 'Activo', color: 'verde' },
  CADUCADO: { etiqueta: 'Caducado', color: 'gris' },
  REVOCADO: { etiqueta: 'Retirado', color: 'rojo' },
};

export function estadoInvitado(clave) {
  return ESTADO_INVITADO[clave] || ESTADO_POR_DEFECTO;
}

/** Cuánto le queda, dicho como lo diría una persona. */
export function loQueQueda(caducaEn, ahora = new Date()) {
  if (!caducaEn) return '';
  const falta = new Date(caducaEn).getTime() - ahora.getTime();
  if (falta <= 0) return 'Ya caducó';
  // EL VERBO CONCUERDA. «Le quedan 1 hora» es de las cosas que hacen que
  // un sistema parezca escrito por una máquina, y esta pantalla la ve un
  // auditor por encima del hombro de quien la usa. Lo cazó la prueba.
  const cuantos = (n, uno, varios) =>
    n === 1 ? `Le queda 1 ${uno}` : `Le quedan ${n} ${varios}`;

  const horas = Math.floor(falta / 3_600_000);
  if (horas < 1) return 'Le queda menos de una hora';
  if (horas < 24) return cuantos(horas, 'hora', 'horas');
  const dias = Math.floor(horas / 24);
  return cuantos(dias, 'día', 'días');
}

// LA FRASE DEL ENLACE QUE NO SE PUEDE VOLVER A VER.
//
// Va aquí y no dentro del componente porque es la advertencia más
// importante de esta pantalla, y quiero poder probarla: si desaparece,
// alguien cierra el cuadro sin copiar el enlace y tiene que crear otro
// acceso con el auditor delante.
export const AVISO_UNA_VEZ =
  'Cópialo ahora: por seguridad no se puede volver a ver. Si lo pierdes, '
  + 'se crea otro acceso y este se retira.';
